<canvas #starCanvas></canvas>